<template>
<!-- 手机号码 -->
<div>
  <el-form-item :class="{'is-error': errors.has('cellphone')}">
    <el-input v-model="mutableCellphone" :placeholder="$t('placeholder.user.cellphone')" @change="errors.clear()">
    </el-input>
    <span class="el-form-item__error">{{errors.first('cellphone')}}</span>
  </el-form-item>

  <!-- 用户验证码 -->
  <el-form-item :class="{'is-error': errors.has('captcha')}">
    <el-col :span="12">
      <el-input v-model="mutableCaptcha" :placeholder="$t('placeholder.user.captcha')" @change="errors.clear()">
      </el-input>
      <span class="el-form-item__error">{{errors.first('captcha')}}</span>
    </el-col>
    <el-col :span="12">
      <el-button class='v-code-btn' :disabled="sended" @click='sendCaptcha'>
        {{sended ? `已发送（${cooldown}）`: '发送验证码'}}
      </el-button>
    </el-col>
  </el-form-item>
</div>
</template>

<script>
import regexes from '@/config/regexes'
import Validator from '@/mixins/validator'

export default {
  data() {
    return {
      mutableCellphone: this.cellphone,
      mutableCaptcha: this.captcha,
      sended: null,
      cooldown: 0,
      cooldownTimeout: null
    }
  },
  mixins: [Validator],
  props: {
    cellphone: [String, Number],
    captcha: [String, Number],
    reset: {
      type: Boolean,
      default: () => {
        return false
      }
    }
  },
  methods: {
    sendCaptcha() {
      let vm = this

      vm.errors.clear()
      if (!regexes.cellphone.test(vm.mutableCellphone)) {
        vm.errors.add('cellphone', '手机号码格式不正确')
        return
      }

      let cooldown = () => {
        if (vm.cooldown <= 0) {
          vm.sended = false
          window.clearTimeout(vm.cooldownTimeout)
          vm.cooldownTimeout = null
        } else {
          vm.cooldown -= 1
          vm.cooldownTimeout = window.setTimeout(cooldown, 1000)
        }
      }

      vm.$store.dispatch('user/captcha', {
        cellphone: vm.mutableCellphone,
        reset: vm.reset
      }).then(_ => {
        vm.sended = true
        // init cooldown
        vm.cooldown = 61
        cooldown()
      }).catch(err => {
        vm.errors.add('cellphone', err.response.data.message)
      })
    },
    save() {
      let vm = this

      // do validation
      vm.errors.clear()
      if (!regexes.cellphone.test(vm.mutableCellphone)) {
        vm.errors.add('cellphone', '手机号码格式不正确')
        return Promise.reject('validation')
      }

      if (!regexes.captcha.test(vm.mutableCaptcha)) {
        vm.errors.add('captcha', '验证码格式不正确')
        return Promise.reject('validation')
      }

      vm.$emit('update:cellphone', vm.mutableCellphone)
      vm.$emit('update:captcha', vm.mutableCaptcha)
      return Promise.resolve('saved')
    },
    addErrors(field, message) {
      this.errors.add(field, message)
    }
  }
}
</script>

<style lang='scss' scoped>
.v-code-btn {
    float: right;
    color: $font-color-base;
    height: 36px;
    box-sizing: border-box;
    background: $color-gray-light;
    border: none;
    &.is-diabled:focus,
    &.is-diabled:hover,
    &.is-disabled {
        background: lighten($color-gray-light, 5%);
        color: $font-color-light;
    }
    &:not(.is-disabled):focus,
    &:not(.is-disabled):hover {
        color: $font-color-strong;
    }
}
</style>



// WEBPACK FOOTER //
// cellphone.input.vue?0c1df458